//@ts-nocheck
import { Route, Routes } from "react-router-dom";
import PageNotFound from "../pages/ErrorPage/PageNotFound";
import AuthLayout from "../layouts/AuthLayout";
import ConfirmPassordReset from "../pages/Auth/ConfirmPassordReset";
import LoginPage from "../pages/Auth/LoginPage";
import PasswordReset from "../pages/Auth/PasswordReset";
import CreateUser from "../components/Auth/CreateUser";
import PrivateRoute from "./PrivateRoute";

/**
 * Top level application router
 *
 * @returns {JSX.Element}
 */
const Router = (): JSX.Element => {
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute>
            <AuthLayout />
          </PrivateRoute>
        }
      >
        <Route path={"/"} element={<LoginPage />} />
        <Route path={"/forget-password"} element={<PasswordReset />} />
        <Route
          path={"/confirm-password-reset"}
          element={<ConfirmPassordReset />}
        />
        <Route path="/*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

export default Router;
